(() => {
  const initialize = () => {
    document.querySelectorAll('[data-go-gallery-config]').forEach((config) => {
      if (config.dataset.initialized) return;
      config.dataset.initialized = 'true';
      const scope = document.getElementById('MainContent');
      const gallery = scope?.querySelector('media-gallery');
      if (!scope || !gallery) return;
      let indices;
      try { indices = JSON.parse(config.textContent); } catch { return; }
      let previous = -1;
      let syncing = false;
      gallery.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('button.thumbnail');
        if (!thumbnail || syncing || !event.isTrusted) return;
        const index = [...gallery.querySelectorAll('button.thumbnail')].indexOf(thumbnail);
        const bundleIndex = indices.indexOf(index);
        if (bundleIndex < 0) return;
        const control = scope.querySelectorAll('.kaching-bundles__bar-main')[bundleIndex];
        if (control && !control.closest('.kaching-bundles__bar--selected')) control.click();
      });
      const synchronize = () => {
        const controls = [...scope.querySelectorAll('.kaching-bundles__bar-main')];
        const selected = controls.findIndex((control) => control.closest('.kaching-bundles__bar--selected'));
        controls.forEach((control, index) => control.setAttribute('aria-pressed', String(index === selected)));
        if (selected < 0 || selected === previous || indices[selected] === undefined) return;
        const thumbnail = gallery.querySelectorAll('button.thumbnail')[indices[selected]];
        if (!thumbnail) return;
        previous = selected;
        syncing = true;
        thumbnail.click();
        syncing = false;
      };
      let scheduled = false;
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; synchronize(); });
      };
      const observer = new MutationObserver(schedule);
      observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      synchronize();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

